import React from 'react';
import PropTypes from 'prop-types';
import Survey from 'survey-ui';
import tokenProviderFactory from '../api/token_provider';

const SurveyUiContainer = (props) => {
  const {
    surveyId,
    googleAnalyticsSurveyTrackingName,
    customErrorMessage,
    customLoadingMessage,
    completionUrl
  } = props;

  const tokenProvider = tokenProviderFactory();

  if (!surveyId) {
    return null;
  }

  return (
    <Survey
      surveyId={surveyId}
      googleAnalyticsSurveyTrackingName={googleAnalyticsSurveyTrackingName}
      tokenProvider={tokenProvider}
      customErrorMessage={customErrorMessage}
      customLoadingMessage={customLoadingMessage}
      completionUrl={completionUrl}
    />
  );
};

SurveyUiContainer.propTypes = {
  surveyId: PropTypes.string,
  googleAnalyticsSurveyTrackingName: PropTypes.string,
  customErrorMessage: PropTypes.string,
  customLoadingMessage: PropTypes.string,
  completionUrl: PropTypes.string
};

export default SurveyUiContainer;
